/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespDealerDetails_item = {|
  +seller: ?{|
    +serviceId: ?string;
    +trackedPhone: ?{|
      +phoneNumber: ?string;
    |};
    +orderFeedbackPdp: ?{| |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsForm_item",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Phone",
          "name": "trackedPhone",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "phoneNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryConnection",
          "name": "orderFeedbackPdp",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetailsStats_reviews",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetailsFeedback_reviews",
              "args": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerDetailsFeedback_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerDetailsStats_seller",
          "args": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
